import { PlusOutlined, RightOutlined } from '@ant-design/icons'
import React from 'react'
import './sectionHeader.scss'

const SectionHeader = ({
  title,
  subtitle,
  buttonText,
  onButtonClick,
  buttonText2,
  onButtonClick2,
  iconType = 'default',
  buttonDisabled = false,
  buttonDisabled2 = false,
  icon1 = null,
  icon2 = null,
  buttonColor1 = '#117ffa',
  buttonColor2 = '#117ffa',
}) => {
  const returnButton = () => {
    if (iconType === 'default')
      return <PlusOutlined style={{ marginLeft: '4px', fontWeight: '700' }} />
    if (iconType === 'arrow-right')
      return <RightOutlined style={{ marginLeft: '4px', fontWeight: '700' }} />
  }
  return (
    <div className="common-aops-header">
      <div className="common-header">
        <div className="section-header-left">
          <div className="standalone-schedule-title">{title}</div>
          <div className="standalone-schedule-subtitle">{subtitle}</div>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          {buttonText && (
            <>
              <button
                className="register-button"
                style={{ borderColor: buttonColor1, color: buttonColor1 }}
                onClick={onButtonClick}
                disabled={buttonDisabled}
              >
                {icon1 && icon1}
                {buttonText}
                {returnButton()}
              </button>
            </>
          )}
          {buttonText2 && (
            <>
              <button
                className="register-button"
                style={{ borderColor: buttonColor2, color: buttonColor2 }}
                onClick={onButtonClick2}
                disabled={buttonDisabled2}
              >
                {icon2 && icon2}
                {buttonText2}
                {returnButton()}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default SectionHeader
